import React from 'react';
import { Login, LoginForm } from 'ra-ui-materialui';
import { withStyles } from '@material-ui/core/styles';
import configuration from './config.js';
const styles = {
    login: {
        main: {
            backgroundImage: 'url(banner.jpg) !important',
          //  background: '#e1e1e1 !important'
        },
        card: {
            padding: '5px 0 15px 0',
        },
         
    },
    form: {
        root : {
                display : "none !important"
            },
        button: {
            height: '3em',
        },
    },
};

const MyLoginForm = withStyles(styles.form)(LoginForm);

const MyLogin = (props) => (
    <React.Fragment>
      <div style={{
        position: 'fixed', right: 0, top: 0, left: 0, zIndex: 100,
        padding: 6,
        //backgroundColor: '#5cc47f',
        //backgroundColor: '#F50057',
        //backgroundColor: '#3f51b5',
        //backgroundColor: '#00608f',
         backgroundColor: '#009688',
        
        textAlign: 'left',
        opacity: 0.9
      }}>
        <img src={configuration.clientLogo +  '/Logo.png'} 
         alt="" height = "50px" 
         style={{  "opacity":"1.0 !important" }}
          />
          
      </div>
      <Login loginForm={<MyLoginForm />} {...props} />

      <div style={{
        position: 'fixed', right: 0, bottom: 0, left: 0, zIndex: 50,
        padding: 6,
        //backgroundColor: '#009688',
       // backgroundColor: 'white',
        textAlign: 'left',
      //  opacity: 0.6
      }}><a href="https://bitcliker.com" target="_blank" rel="noopener noreferrer">
        <img src={ configuration.clientLogo + '/bitCliker.png'} height="50px"  alt="" />
      </a></div> 
    </React.Fragment>

);

export default withStyles(styles.login)(MyLogin);